var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterVizzhy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 73,
    viewBox: "0 0 82 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_310_4966)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_310_4966",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 74,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6271 56.7421C36.6271 61.033 40.0914 64.5122 44.3639 64.5122C48.6364 64.5122 52.1006 61.033 52.1006 56.7421C52.1006 52.4511 48.6364 48.9719 44.3639 48.9719C40.0914 48.9719 36.6271 52.4511 36.6271 56.7421ZM15.8669 34.2765C15.8669 39.6804 20.2309 44.0632 25.6116 44.0632C33.145 44.0632 33.5593 35.7519 44.2114 35.7519C52.4768 35.7519 54.4949 41.5361 58.9046 41.5361C62.8975 41.5361 66.1331 38.2841 66.1331 34.2765C66.1331 30.2689 62.8975 27.0169 58.9046 27.0169C54.3551 27.0169 52.398 32.6735 44.2114 32.6735C33.7093 32.6735 33.1349 24.4872 25.6116 24.4872C20.2309 24.4872 15.8669 28.8701 15.8669 34.2765ZM62.5265 9.78928C62.5265 14.0802 65.9907 17.5594 70.2632 17.5594C74.5357 17.5594 78 14.0802 78 9.78928C78 5.49833 74.5357 2.01912 70.2632 2.01912C65.9907 2.01912 62.5265 5.49578 62.5265 9.78928ZM25.9217 8.18624C17.7351 8.18624 15.778 2.52964 11.2284 2.52964C7.23551 2.52964 4 5.77912 4 9.78928C4 13.7994 7.23551 17.0489 11.2284 17.0489C15.6382 17.0489 17.6563 11.2647 25.9217 11.2647C36.5712 11.2647 36.9855 19.5786 44.5214 19.5786C49.9021 19.5786 54.2661 15.1957 54.2661 9.78928C54.2661 4.38284 49.9021 0 44.5214 0C36.9982 0 36.4238 8.18624 25.9217 8.18624Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_310_4966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 0H4V64.5122H78V0Z",
    fill: "url(#paint0_linear_310_4966)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_310_4966",
    x: 0,
    y: 0,
    width: 82,
    height: 72.5122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_310_4966"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_310_4966",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_4966",
    x1: 3.96188,
    y1: 32.094,
    x2: 77.939,
    y2: 32.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#EF528C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#676BB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterVizzhy);
export default __webpack_public_path__ + "static/media/footer-vizzhy.e5a154365979f51f1309c2371a004444.svg";
export { ForwardRef as ReactComponent };